var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar'),_vm._v(" "),_c('section-layout',[_c('template',{slot:"center"})],2),_vm._v(" "),_c('home'),_vm._v(" "),_c('gallery'),_vm._v(" "),_c('logos'),_vm._v(" "),_c('footer-text')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b248494","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 181
// module chunks = 0